import { Paper, Stack, Button, Flex, Box } from "@mantine/core";
import BankIDLogo from "../../assets/bank-id-logo.svg?react";
import { LoginActionsProps } from "../../types";
import { FooterButtons } from "../footerButtons";
import { isMobileDevice } from "../../utils/useDeviceDetection";

export function LoginActions({ onLogin, loginLoading }: LoginActionsProps) {
  const isMobile = isMobileDevice();

  const buttons = (
    <Stack align="center" w="100%">
      <Button
        fullWidth
        onClick={onLogin}
        disabled={loginLoading}
        loading={loginLoading}
      >
        <Flex component="span" align="center">
          <Box component="span" mr="0.5rem">
            Logga in
          </Box>
          <BankIDLogo role="img" aria-label="BankID" />
        </Flex>
      </Button>

      <Button
        variant="default"
        fullWidth
        component="a"
        href={import.meta.env.VITE_LANDING_URL}
      >
        Tillbaka till startsidan
      </Button>
    </Stack>
  );

  if (isMobile) {
    return <FooterButtons>{buttons}</FooterButtons>;
  }

  return (
    <Paper pt="md" radius="24px" mb="2rem">
      {buttons}
    </Paper>
  );
}
